import React, { Component } from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import MonthPicker from '../MonthPicker';
import LoadMoreIcon from './../LoadMoreIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import { paginationLimit } from './../../helpers.js'

/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false,
    startDate: new Date(),
    anchorEl: null,
    downloads: [],
    isNoDownloadBtnShown: false,
    isLoadMoreListing: false
  }


  fetchDownloads = (skip=0) => {

    this.props.fetchDownloads({
      params:
      {
        type: this.props.location.pathname.includes('programs') ? 'program' : 'workout',
        startDate: this.state.startDate,
        limit: paginationLimit.TEN,
        skip: skip
      }
    }).then((data) => {

      let downloads = data.list;
      if (skip !== 0) {
        downloads = [...this.state.downloads, ...downloads]
      }
      this.setState({
        ...this.state,
        dataLoaded: true,
        downloads: downloads,
        isNoDownloadBtnShown: true,
        isLoadMoreListing:  data.list.length < paginationLimit.TEN ? false : true
      })
    });
  };

  componentDidMount() {
    this.fetchDownloads();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ ...this.state, search: '' })
      this.fetchDownloads();
    }
  }

  handleChange = date => {
    this.setState({
      startDate: date,
      downloads: [],
      isNoDownloadBtnShown: false,
      isLoadMoreListing: false
    }, () => {
      this.fetchDownloads();
    });
  };

  viewNotes(workout, email, index) {
    const { getPlanNotes  } = this.props;
    this.setState({
      openWorkout: false
    })
    getPlanNotes({
      email,
      workoutId: workout._id
    }).then((data) => {
      this.setState({
        openWorkout: true,
        planNotes: data.planNotes,
        selectedWorkout: workout
      })
      this.handleClose(index)
    });
  }
 
  render() {
    const { downloads, isLoadMoreListing, isNoDownloadBtnShown } = this.state;
    if (this.state.dataLoaded) {
      return (
        <div>
          <NavigationTabs
            title="Track Workout Downloads"
            subtitle=""
            set="downloads"
            activeRoute={this.props.location.pathname.includes('workout') ? "/download/workout" : "/download/programs"} />
          <div className="filter-by-row">
            <h4>Filter By Month</h4>
            <MonthPicker
              selected={this.state.startDate}
              onChange={this.handleChange}
            />
          </div>
          <div
							style={{
								overflow: 'auto',
								height: 400
							}}
							id = "scrollableDiv"
						>
          <InfiniteScroll
                dataLength={downloads.length} //This is important field to render the next data
                next={() => this.fetchDownloads(downloads.length)}
                hasMore={isLoadMoreListing}
                scrollableTarget="scrollableDiv"
                loader={
                  <LoadMoreIcon/>
                }
              >
          <table className="table">
            {
              downloads.length > 0 &&
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Downloads</th>
                </tr>
              </thead>
            }
            {
              downloads.length === 0 &&  isNoDownloadBtnShown &&
              <tr>
                <td colSpan="4" style={{ "textAlign": 'center', paddingTop: "20px" }}><h1>No Downloads</h1></td>
              </tr>
            }
            <tbody>
              {
                downloads.length > 0 && downloads.map((download, i) => {
                  return (
                    <tr key={i}>
                      <td className="email">{download.name}</td>
                      <td>{download.count}</td>
                      </tr>
                  )
                })
              }

            </tbody>
          </table>
          </InfiniteScroll>
          </div>
        </div>

      );
    }
    return null;
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/downloads/list.js